import { Wifi, WifiOff, Bell, RefreshCw, AlertCircle } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { ActiveNotificationChannel } from '@rondela/shared'

interface ChannelIndicatorProps {
  channel: ActiveNotificationChannel
  className?: string
}

const channelConfig: Record<
  ActiveNotificationChannel,
  { icon: LucideIcon; label: string; color: string; description: string }
> = {
  websocket: {
    icon: Wifi,
    label: 'Tiempo real',
    color: 'var(--color-success)',
    description: 'Conectado via WebSocket',
  },
  push: {
    icon: Bell,
    label: 'Push',
    color: 'var(--color-info)',
    description: 'Notificaciones push activas',
  },
  polling: {
    icon: RefreshCw,
    label: 'Polling',
    color: 'var(--color-warning)',
    description: 'Actualizaciones periódicas',
  },
  mock: {
    icon: AlertCircle,
    label: 'Mock',
    color: 'var(--color-warning)',
    description: 'Modo de desarrollo (simulado)',
  },
  disconnected: {
    icon: WifiOff,
    label: 'Desconectado',
    color: 'var(--color-text-tertiary)',
    description: 'Sin conexión en tiempo real',
  },
}

export function ChannelIndicator({ channel, className = '' }: ChannelIndicatorProps) {
  const config = channelConfig[channel]
  const Icon = config.icon

  return (
    <div className={`channel-indicator ${className}`} title={config.description}>
      <Icon size={12} style={{ color: config.color }} />
      <span className="channel-indicator__label" style={{ color: config.color }}>
        {config.label}
      </span>

      <style>{`
        .channel-indicator {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-1);
          padding: var(--spacing-1) var(--spacing-2);
          border-radius: var(--radius-full);
          background: var(--color-bg-tertiary);
          font-size: var(--font-size-xs);
          cursor: default;
        }

        .channel-indicator__label {
          font-weight: 500;
        }
      `}</style>
    </div>
  )
}
